import styled from 'styled-components'

import { spacing } from '../../themes'

export const ButtonRadioContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing(2)};
`
